import { useEffect, useState } from 'react';
import { cn } from '@Utils/cn';

// Shown when an agent owns no operation with its own copy, or owns none at all.
const FALLBACK_LINES = ['On duty'];

/**
 * A gently rotating "voice" line that makes the agent feel present.
 *
 * Lines are dispositional — always-true statements about what the agent watches
 * for — NOT a claim that a job is running right now. They come from the owned
 * operations' metadata so each persona speaks to its own domain.
 */
export default function PresenceLine({
  lines,
  className,
}: {
  lines?: string[];
  className?: string;
}) {
  const rotation = lines?.length ? lines : FALLBACK_LINES;
  const [index, setIndex] = useState(0);

  // Reset when the line set changes, or the index can point past the end of a
  // shorter list.
  useEffect(() => {
    setIndex(0);
  }, [lines]);

  useEffect(() => {
    if (rotation.length < 2) return;
    const timer = setInterval(
      () => setIndex((n) => (n + 1) % rotation.length),
      4500,
    );
    return () => clearInterval(timer);
  }, [rotation]);

  return (
    <div
      className={cn(
        'inline-flex items-center gap-1.5 text-xs text-zinc-500',
        className,
      )}
    >
      <span aria-hidden>✨</span>
      {/* key re-mounts the span so the fade-up replays on each line change */}
      <span key={index} className="agent-thought-in italic">
        {rotation[index]}
      </span>
    </div>
  );
}
